import { useQuery } from '@tanstack/react-query';
import AdsService from '../../services/AdsService';

export const adKeys = {
  all: ['ads'],
  byLocation: (location) => [...adKeys.all, 'location', location],
};

export function useAdsByLocation(location) {
  return useQuery({
    queryKey: adKeys.byLocation(location),
    queryFn: () => AdsService.listAds(location),
    enabled: !!location,
    staleTime: false,
    gcTime: false,
    retry: 2,
  });
}
